import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-instructions-method",
	imports: [COMMON_IMPORTS, LangValPipe, CancelBtnComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row confirm-modal">
			<div class="col-12">
				<button
					class="btn btn-primary"
					(click)="onClose.emit({ isWhatsapp: false })"
				>
					{{ "phone" | langVal }}
				</button>
				<button
					class="btn btn-primary"
					(click)="onClose.emit({ isWhatsapp: true })"
				>
					{{ "whatsapp" | langVal }}
				</button>
			</div>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
		</div>
	`,
})
export class InstructionsMethodComponent extends Modalable {}
